import React, { useEffect, useState } from "react";
import { TextInput } from "carbon-components-react";

import TextInputProps from "./types";

const eventSetNameAndValue = (
  e: React.FocusEvent<HTMLInputElement> | React.ChangeEvent<HTMLInputElement>,
  name: string,
  value: string,
) => ({
  ...e,
  target: {
    ...e.target,
    name,
    value,
  },
});

interface Props extends TextInputProps {
  formValueToDisplayValue(value: string | number): string;
  formValueToEditableValue(value: string | number): string;
  editableValueToFormValue(value: string | number): string;
}

const FormattedNumberInput = (props: Props) => {
  const {
    formValueToDisplayValue,
    formValueToEditableValue,
    editableValueToFormValue,
    ...textInputProps
  } = props;

  const { name, value, onFocus = () => {}, onBlur = () => {}, onChange } = textInputProps;

  // empty strings must be handled in the same way regardless of whatever wraps this component
  const formToDisplay = (v: string | number) => (v === "" ? "" : formValueToDisplayValue(v));
  const formToEditable = (v: string | number) => (v === "" ? "" : formValueToEditableValue(v));
  const editableToForm = (v: string | number) => (v === "" ? "" : editableValueToFormValue(v));

  const [formattedValue, setFormattedValue] = useState<string>(formToDisplay(value));
  const [editing, setEditing] = useState<boolean>(false);

  useEffect(() => {
    setFormattedValue(formToDisplay(value));
  }, [value]);

  return (
    <TextInput
      {...textInputProps}
      value={editing ? value : formattedValue}
      onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
        onChange(eventSetNameAndValue(e, name, formToEditable(value)));
        setEditing(true);
        onFocus(e);
      }}
      onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
        onChange(eventSetNameAndValue(e, name, editableToForm(value)));
        setEditing(false);
        onBlur(e);
      }}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(eventSetNameAndValue(e, name, e.target.value.replace(/[^0-9.-]/g, "")));
      }}
    />
  );
};

export { TextInputProps };

export default FormattedNumberInput;
